var industryInfo={
    classList:[
        {
            'name':"",
            'list':[
                {
                    'videoUrl':"",
                    'title':"",
                    'lable':"",
                    'list':[
                        
                    ]
                }
            ]
        }       
    ],
    name:"原材料加工",
    title:"solutions",
    subtitle:"原材料加工行业应用案例",
    subinfo:"我们的可为原材料加工行业提供伺服驱动器解决方案。",
}

export default {
    industryInfo
  };    


// WEBPACK FOOTER //
// ./src/data/industryInfo/10.js